if (!customElements.get('wlsn-buybox-sticky')) {
  class WLSNStickyBuybox extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        buybox: 'wlsn-buybox',
        footer: 'wlsn-footer'
      };

      // Array of selectors that should hide the sticky buybox when visible
      this.hideConditions = [
        {
          selector: `.${this.classes.buybox}`,
          description: 'Buybox',
        },
        {
          selector: `.${this.classes.footer}`,
          description: 'Footer',
        },
      ];

      this.observers = {};
      this.visibilityStates = {};
      this.elementsCache = null;

      this.boundHandleResize = this._handleResize.bind(this);
    }

    get elements() {
      if (!this.elementsCache) {
        this.elementsCache = {
          buybox: this.closest(`.${this.classes.buybox}`),
        };
      }
      return this.elementsCache;
    }

    connectedCallback() {
      setTimeout(() => {
        this._init();
      }, 0);
    }

    disconnectedCallback() {
      this._cleanup();
    }

    _init() {
      if (!this.elements.buybox) {
        console.warn('[WLSNStickyBuybox] Missing required elements');
        return;
      }

      this._setupHideConditions();
      this._setupIntersectionObservers();
      window.addEventListener('resize', this.boundHandleResize, { passive: true });
    }

    _setupHideConditions() {
      if (!this.elementsCache) {
        this.elementsCache = { buybox: this.closest(`.${this.classes.buybox}`) };
      }
      this.hideConditions.forEach((condition, index) => {
        const element = document.querySelector(condition.selector);
        if (element) {
          this.elementsCache[`condition${index}`] = element;
          this.visibilityStates[`condition${index}`] = false;
        } else {
          console.warn(
            `[WLSNStickyBuybox] Could not find element for ${condition.description} (${condition.selector})`
          );
        }
      });
    }

    _setupIntersectionObservers() {
      this.hideConditions.forEach((condition, index) => {
        const element = this.elements[`condition${index}`];
        if (!element) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isVisible = entry.intersectionRatio > 0.2;
              this.visibilityStates[`condition${index}`] = isVisible;
              this._updateStickyState();
            });
          },
          {
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
            rootMargin: '0px 0px 0px 0px',
          }
        );

        observer.observe(element);
        this.observers[`condition${index}`] = observer;
      });
    }

    _handleResize() {
      this._updateStickyState();
    }

    _updateStickyState() {
      const anyHideConditionVisible = Object.values(this.visibilityStates).some((state) => state === true);
      const shouldShowSticky = !anyHideConditionVisible;

      if (shouldShowSticky) {
        this._showSticky();
      } else {
        this._hideSticky();
      }
    }

    _showSticky() {
      if (!this.classList.contains(this.classes.active)) {
        this.classList.add(this.classes.active);
      }
    }

    _hideSticky() {
      if (!this.classList.contains(this.classes.active)) {
        return;
      }
      this.classList.remove(this.classes.active);
    }

    _cleanup() {
      Object.values(this.observers).forEach((observer) => {
        if (observer) {
          observer.disconnect();
        }
      });
      window.removeEventListener('resize', this.boundHandleResize);
      this.elementsCache = null;
    }
  }

  customElements.define('wlsn-buybox-sticky', WLSNStickyBuybox);
}
